import React from 'react';
import PropTypes from 'prop-types';

import Button from 'Components/Button';

const DashedButton = ({
    children,
    ...props
}) => {
  return (
    <Button
      category="dashed"
      {...props}
    >
      {children}
    </Button>
  );
};

DashedButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default DashedButton;
